<template>
    <div v-if="!loading">
        <div v-if="fullMode">
            <div v-if="loggedIn">
                <div>
                    <el-container>
                        <el-aside width="200px" v-if="!isPrintMode">
                            <el-menu
                                background-color="#545c64"
                                text-color="#fff"
                                class="el-menu--vertical"
                                active-text-color="#09b3af"
                            >
                                <el-menu-item
                                    index="1"
                                    @click="navigateToReports()"
                                >
                                    <img
                                        src="/static/netural_logo.svg"
                                        class="logo"
                                    />
                                </el-menu-item>
                                <el-menu-item
                                    v-if="hasUserRolePermission('sales')"
                                    index="2"
                                    @click="sidebarClick(509644)"
                                >
                                    Sales
                                </el-menu-item>
                                <el-menu-item
                                    v-if="hasUserRolePermission('catalogue')"
                                    index="3"
                                    @click="sidebarClick(509643)"
                                >
                                    Catalogue
                                </el-menu-item>
                                <el-menu-item
                                    v-if="
                                        isVisible &&
                                        hasUserRolePermission('contents')
                                    "
                                    index="4"
                                    @click="sidebarContentsClick()"
                                >
                                    Contents
                                </el-menu-item>
                                <el-menu-item
                                    v-if="
                                        hasUserRolePermission('configuration')
                                    "
                                    index="5"
                                    @click="sidebarClick(509645)"
                                >
                                    Configuration
                                </el-menu-item>
                                <el-submenu
                                    v-if="isVisible && !isRestricted('report') && !isRestricted('customer_registrations')"
                                    index="6"
                                >
                                    <template slot="title">Statistics</template>
                                    <el-menu-item
                                        index="6-1"
                                        @click="navigateToStatistics()"
                                    >
                                        Reports
                                    </el-menu-item>
                                    <el-menu-item
                                        index="6-2"
                                        @click="navigateToCustomerRegistrations()"
                                    >
                                        Registrations
                                    </el-menu-item>
                                </el-submenu>
                                <el-menu-item
                                    v-if="
                                        hasUserRolePermission(
                                            'coupons_customer_support'
                                        ) && isCustomerSupport()
                                    "
                                    index="7"
                                    @click="sidebarClick(523060705)"
                                >
                                    Coupon
                                </el-menu-item>
                                <div class="el-menu__logout">
                                    <el-button
                                        @click="onLogout()"
                                        class="el-menu__logout-button"
                                        type="primary"
                                        >Logout</el-button
                                    >
                                </div>
                            </el-menu>
                        </el-aside>
                        <el-main>
                            <el-menu
                                v-if="!isPrintMode"
                                default-active="1"
                                @select="handleSelect"
                                mode="horizontal"
                            >
                                <template
                                    v-for="(nav, index) in getVisibleTabItems(
                                        config.body
                                    )"
                                >
                                    <el-menu-item
                                        v-if="
                                            hasUserRolePermission(
                                                nav.route.toLowerCase()
                                            ) &&
                                            !isRestricted(
                                                nav.route.toLowerCase()
                                            ) &&
                                            !isCustomerSupport()
                                        "
                                        :key="index"
                                        :index="nav.route"
                                    >
                                        <span>{{ nav.name }}</span>
                                    </el-menu-item>
                                </template>
                            </el-menu>
                            <div
                                v-bind:class="{ container: config.body.length }"
                                v-if="activeConfig != null"
                            >
                                <div
                                    :is="activeConfig.component"
                                    :model="model"
                                    :action="action"
                                    :id="id"
                                    :root-config="config"
                                    :config="activeConfig"
                                    :site-id="login.site_id"
                                    :permitted-sites-config="
                                        permittedSitesConfig
                                    "
                                ></div>
                            </div>
                        </el-main>
                    </el-container>
                </div>
            </div>
            <div v-else>
                <el-container>
                    <el-main class="login__container">
                        <el-form
                            :model="login"
                            status-icon
                            ref="login"
                            label-width="120px"
                            class="login"
                            @submit.prevent.native="submitForm"
                        >
                            <el-form-item label="Shop ID" prop="site_id">
                                <el-input
                                    type="site_id"
                                    v-model="login.site_id"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="Email" prop="email">
                                <el-input
                                    type="email"
                                    v-model="login.email"
                                ></el-input>
                            </el-form-item>
                            <el-form-item label="Password" prop="password">
                                <el-input
                                    type="password"
                                    v-model="login.password"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button native-type="submit" type="primary"
                                    >Login</el-button
                                >
                            </el-form-item>
                        </el-form>
                    </el-main>
                </el-container>
            </div>
        </div>
        <div v-else>
            <el-menu
                default-active="1"
                @select="handleSelect"
                mode="horizontal"
            >
                <template
                    v-for="(nav, index) in getVisibleTabItems(config.body)"
                >
                    <el-menu-item
                        v-if="
                            hasUserRolePermission(nav.route.toLowerCase()) &&
                            !isRestricted(nav.route.toLowerCase())
                        "
                        :key="index"
                        :index="nav.route"
                    >
                        <span>{{ nav.name }}</span>
                    </el-menu-item>
                </template>
            </el-menu>
            <div class="container" v-if="activeConfig != null">
                <div
                    :is="activeConfig.component"
                    :model="model"
                    :action="action"
                    :id="id"
                    :root-config="config"
                    :config="activeConfig"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import apiHelper from '../libs/api';
import encryptStorage from '../libs/encryptStorage';
import params from '../libs/params';
import convertSettings from '../libs/settings';
import schema from '../schema';
import CustomerRegistrations from './CustomerRegistrations';
import Dashboard from './Dashboard';
import Install from './Install';
import ReportDetail from './ReportDetail';
import Reports from './Reports';
import Settings from './Settings';
import VueCrud from './VueCrud';

const domainToApiMap = {
    // PROD
    'wh.admin.commerce.netural.com': 'wh.api.commerce.netural.com',
    'silhouette.admin.commerce.netural.com':
        'silhouette.api.commerce.netural.com',
    // QA
    'qa-wh.admin.commerce.netural.com': 'qa.wh.api.commerce.netural.com',
    'qa-silhouette.admin.commerce.netural.com':
        'qa.silhouette.api.commerce.netural.com',
    'qa.admin.commerce.netural.com': 'qa.api.commerce.netural.com', // ToDo: Remove after Go-Live
    // TEST
    'test-wh.admin.commerce.netural.com': 'qa.wh.api.commerce.netural.com',
    'test-silhouette.admin.commerce.netural.com':
        'qa.silhouette.api.commerce.netural.com',
    // LOCAL
    'localhost:8443': 'qa.silhouette.api.commerce.netural.com', // For local development replace the empty string with the API you want to use
};
const currentHost = window.location.host;
const apiHost = domainToApiMap[currentHost];
const apiEndpoint = apiHost ? `https://${apiHost}/v1` : undefined;
const isQaApiEndpoint = apiHost && apiHost.startsWith('qa.');

export default {
    name: 'admin',

    props: ['id', 'model', 'action'],

    data() {
        return {
            login: {
                site_id: localStorage.getItem('site_id'),
                email: '',
                password: '',
            },
            loading: true,
            config: {
                component: 'v-admin',
                endPoint: apiEndpoint,
                headers: {},
                body: [],
            },
            customerSettings: {
                tabs: null,
            },
            firstRedirect: true,
            fullMode: false,
            loggedIn: false,
            isPrintMode: false,
            permittedSitesConfig: {
                'wh-atde': 42683,
                'wh-fr': 42718,
                'wh-bg': 42710,
                'wh-au': 42699,
                'wh-ca': 42639,
                'wh-in': 42730,
                'wh-pl': 42737,
                'wh-tr': 42738,
                'wh-ib': 42781,
                'wh-dk': 42839,
                'wh-se': 42840,
            },
            userRole: encryptStorage.getItem('ur'),
            userPermission: {
                Storefront: [],
                Api: [],
                SuperMana: [],
                SuperManage: [],
                Superadmin: [],
                Admin: [],
                BRAdmin: [],
                UKAdmin: [],
                USAdmin: [],
                CustomerSup: [
                    'configuration',
                    'general',
                    'settings',
                    'canned_messages',
                    'site_countries',
                    'site_country_zones',
                    'customer_groups',
                    'prices',
                    'pricelists',
                    'tax_categories',
                    'tax_rates',
                    'origins',
                    'users',
                    'dashboard',
                    'contents',
                    'coupons',
                    'discounts',
                    'checkouts',
                    'newsletter_subscribers',
                    'categories',
                    'properties',
                    'testimonials',
                    'assets',
                    'checkouts',
                    'sales',
                    'catalogue',
                ],
                Manager: [],
                Warehouse: [
                    'configuration',
                    'general',
                    'settings',
                    'canned_messages',
                    'site_countries',
                    'site_country_zones',
                    'customer_groups',
                    'prices',
                    'pricelists',
                    'tax_categories',
                    'tax_rates',
                    'origins',
                    'users',
                    'dashboard',
                    'contents',
                    'coupons',
                    'discounts',
                    'checkouts',
                    'newsletter_subscribers',
                    'categories',
                    'properties',
                    'testimonials',
                    'assets',
                ],
                Orders: [
                    'configuration',
                    'general',
                    'settings',
                    'canned_messages',
                    'site_countries',
                    'site_country_zones',
                    'customer_groups',
                    'prices',
                    'pricelists',
                    'tax_categories',
                    'tax_rates',
                    'origins',
                    'users',
                    'dashboard',
                    'contents',
                    'catalogue',
                    'products',
                    'categories',
                    'properties',
                    'testimonials',
                    'assets',
                    'checkouts',
                ],
                Reports: [
                    'configuration',
                    'general',
                    'settings',
                    'canned_messages',
                    'site_countries',
                    'site_country_zones',
                    'customer_groups',
                    'prices',
                    'pricelists',
                    'tax_categories',
                    'tax_rates',
                    'origins',
                    'users',
                    'dashboard',
                    'contents',
                    'coupons',
                    'discounts',
                    'checkouts',
                    'newsletter_subscribers',
                    'products',
                    'categories',
                    'properties',
                    'assets',
                ],
            },
            restrictedRoutes: encryptStorage.getItem('rr'),
        };
    },

    watch: {
        $route(routeTo) {
            this.isPrintMode = routeTo.params.action === 'print';
        },
    },

    computed: {
        activeConfig: function () {
            if (this.isRestricted(this.model)) {
                return;
            }
            if (!Object.hasOwn(this.userPermission, this.userRole)) {
                return;
            }
            if (
                !this.hasUserRolePermission(this.model) &&
                typeof this.model !== 'undefined'
            ) {
                return;
            }
            if (
                this.model === 'users' ||
                this.model === 'newsletter_subscribers' ||
                this.model === 'report' ||
                this.model === 'customer_registrations' ||
                typeof this.model === 'undefined'
            ) {
                let site_id = this.login.site_id;

                if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                    site_id = this.permittedSitesConfig[`${site_id}`];
                }

                const isPermittedSite = Object.values(
                    this.permittedSitesConfig
                ).includes(Number(site_id));

                if (!isPermittedSite) {
                    return;
                }

                if (this.model === 'customer_registrations') {
                    return { component: 'customer-registrations' };
                }

                if (
                    this.model === 'report' ||
                    typeof this.model === 'undefined'
                ) {
                    if (this.id) {
                        return { component: 'report', id: this.id };
                    }
                    return {
                        component: 'reports',
                        name: 'Reports',
                        route: 'reports',
                    };
                }
            }

            let model = this.config.body.filter((e) => {
                return e.route === this.model;
            });

            if (model.length > 0) {
                return model[0];
            }

            return null;
        },
        isVisible() {
            let site_id = this.login.site_id;

            if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                site_id = this.permittedSitesConfig[`${site_id}`];
            }

            return Object.values(this.permittedSitesConfig).includes(
                Number(site_id)
            );
        },
    },

    created() {
        if (this.config.endPoint) {
            this.loadCustomerSettings();

            let group = params('group');
            if (params('_storyblok')) {
                this.loadConfig();

                if (isQaApiEndpoint) {
                    this.registerStoryblok();
                }
            } else {
                if (sessionStorage.getItem('sbc-token') !== null) {
                    this.loggedIn = true;
                    this.$router.push('/');
                }

                if (window.location !== window.parent.location) {
                    this.config.body = schema[group] || schema.default;
                    this.initRoute();
                    this.firstRedirect = false;
                } else {
                    this.loading = false;
                    this.fullMode = true;
                }
            }
        }
    },
    mounted() {
        const sessionExpired = sessionStorage.getItem('session-expired');
        if (sessionExpired) {
            sessionStorage.removeItem('session-expired');
            this.$notify({
                title: 'Your session has expired.',
                message: 'Please log in.',
                duration: 10000,
            });
            this.$router.push('/');
        }

        // console.log(encryptStorage.getItem('ur'));
    },

    components: {
        'v-crud': VueCrud,
        'customer-registrations': CustomerRegistrations,
        settings: Settings,
        install: Install,
        dashboard: Dashboard,
        reports: Reports,
        report: ReportDetail,
    },

    methods: {
        isRestricted(route) {
            if (!this.restrictedRoutes) {
                return false;
            }
            const restrictedRoutes = this.restrictedRoutes.split(',');
            if (
                (route === 'report' || route === 'customer_registrations' || typeof this.model === 'undefined') &&
                restrictedRoutes.includes('show_sales')
            ) {
                return true;
            }
            if (
                (route === 'coupons' ||
                    route === 'discounts' ||
                    route === 'newsletter_subscribers') &&
                restrictedRoutes.includes('marketing')
            ) {
                return true;
            }
            if (
                route === 'settings' &&
                restrictedRoutes.includes('edit_advanced_layout')
            ) {
                return true;
            }
            return false;
        },
        hasUserRolePermission(route) {
            if (!Object.hasOwn(this.userPermission, this.userRole)) {
                return false;
            }
            return !this.userPermission[`${this.userRole}`].includes(route);
        },
        sidebarClick(route) {
            this.firstRedirect = true;
            this.loadConfig(route);
        },
        async sidebarContentsClick() {
            const settings = await this.getSettings();
            if (
                settings &&
                settings.general_setting &&
                settings.general_setting.storyblok_url
            ) {
                window.open(settings.general_setting.storyblok_url, '_blank');
            }
        },

        navigateToReports() {
            this.config.body = [];
            this.$router.push({ name: 'home' });
        },

        navigateToStatistics() {
            this.config.body = [];
            this.$router.push({
                name: 'admin',
                params: { model: 'report', id: 'order_details', action: 'all' },
            });
        },

        navigateToCustomerRegistrations() {
            this.config.body = [];
            this.$router.push({
                name: 'admin',
                params: { model: 'customer_registrations', id: 'all', action: 'index' },
            });
        },

        onLogout() {
            let sessionApi = this.$resource(
                this.config.endPoint + '/user_sessions/me'
            );
            sessionApi
                .delete()
                .then(() => {
                    encryptStorage.removeItem('ur');
                    encryptStorage.removeItem('rr');
                    sessionStorage.removeItem('sbc-token');
                    sessionStorage.removeItem('tableFilter');
                    this.$router.push('/');
                    this.loggedIn = false;
                })
                .catch(apiHelper.errorHandler);
        },

        submitForm() {
            let site_id = this.login.site_id;

            if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                site_id = this.permittedSitesConfig[`${site_id}`];
            }

            const login = {
                site_id,
                email: this.login.email,
                password: this.login.password,
            };

            let sessionApi = this.$resource(
                this.config.endPoint + '/user_sessions'
            );

            sessionApi
                .save(login)
                .then((res) => {
                    this.userRole = res.body.access;
                    encryptStorage.setItem('ur', res.body.access);
                    this.restrictedRoutes = res.body.disallow;
                    encryptStorage.setItem('rr', this.restrictedRoutes);
                    localStorage.setItem('site_id', this.login.site_id);
                    sessionStorage.setItem(
                        'sbc-token',
                        res.headers.map.token[0]
                    );
                    this.config.headers['Authorization'] =
                        sessionStorage.getItem('sbc-token');
                    this.$router.push('/');
                    this.loggedIn = true;
                })
                .catch(apiHelper.errorHandler);
        },
        getVisibleTabItems(items) {
            let site_id = this.login.site_id;

            if (Object.hasOwn(this.permittedSitesConfig, site_id)) {
                site_id = this.permittedSitesConfig[`${site_id}`];
            }

            const filteredItemsByCustomerSettings = items.filter((item) => {
                const tabSetting = this.customerSettings.tabs.find(
                    (tab) => tab.route === item.route
                );

                if (tabSetting) {
                    return tabSetting.isVisibleFor.includes(site_id.toString());
                }

                return true;
            });

            return filteredItemsByCustomerSettings;
        },

        loadCustomerSettings() {
            let stories = this.$resource(
                'https://api.storyblok.com/v2/cdn/stories/customer-settings'
            );
            let version = 'published';

            if (isQaApiEndpoint) {
                version = 'draft';
            }

            stories
                .get({
                    id: params('_storyblok'),
                    token: '7aJS9owJrpRWCa8d3iofRQtt',
                    version: version,
                    cv: Date.now(),
                })
                .then((res) => {
                    this.customerSettings = res.body.story.content;
                });
        },

        loadConfig(id) {
            let stories = this.$resource(
                'https://api.storyblok.com/v2/cdn/stories/{id}'
            );
            let version = 'published';

            if (isQaApiEndpoint) {
                version = 'draft';
            }

            stories
                .get({
                    id: id || params('_storyblok'),
                    token: '7aJS9owJrpRWCa8d3iofRQtt',
                    version: version,
                    cv: Date.now(),
                })
                .then((res) => {
                    this.config.body = res.body.story.content.body;
                    this.initRoute();
                    this.firstRedirect = false;
                });
        },

        registerStoryblok() {
            window.storyblok.init();

            window.storyblok.on('change', () => {
                this.loadConfig();
            });

            window.storyblok.on('published', () => {
                this.loadConfig();
            });

            window.storyblok.pingEditor(function () {
                if (window.storyblok.inEditor) {
                    window.storyblok.enterEditmode();
                }
            });
        },

        initRoute() {
            let first = this.config.body[0];
            if (this.firstRedirect && !this.isCustomerSupport()) {
                this.$router.push({
                    name: 'admin',
                    params: { model: first.route, id: 'all', action: 'index' },
                });
            } else if (this.firstRedirect && this.isCustomerSupport()) {
                this.$router.push({
                    name: 'admin',
                    params: { model: first.route, id: 'all', action: 'new' },
                });
            }

            if (params('storeblok')) {
                let url =
                    'https://' +
                    params('storeblok') +
                    '/admin/users/get_api_provision';
                let api = this.$resource(url, {}, {}, { credentials: true });

                api.get().then((res) => {
                    this.userRole = res.body.access;
                    encryptStorage.setItem('ur', res.body.access);
                    sessionStorage.setItem('sbc-token', res.body.access_token);
                    this.config.headers['Authorization'] =
                        res.body.access_token;

                    this.loading = false;
                    this.stripeRedirect();
                });
            } else if (params('_storyblok')) {
                window.storyblok.getSession((data) => {
                    sessionStorage.setItem(
                        'sbc-token',
                        data.session.access_token
                    );
                    this.config.headers['Authorization'] =
                        data.session.access_token;
                    this.loading = false;
                    this.stripeRedirect();
                });
            } else {
                this.loading = false;
                this.stripeRedirect();
            }
        },

        stripeRedirect() {
            if (window.location.search.indexOf('?stripe_connected=1') > -1) {
                this.$router.push({
                    name: 'admin',
                    params: { model: 'settings', id: 'all', action: 'index' },
                });
            }
        },

        handleSelect(index) {
            this.$router.push({
                name: 'admin',
                params: { model: index, id: 'all', action: 'index' },
            });
        },

        async getSettings() {
            return new Promise((resolve) => {
                const api = this.$resource(
                    this.config.endPoint + '/bulk_settings/{id}',
                    {},
                    {},
                    { headers: this.config.headers }
                );

                api.get({ id: 'mine' }).then((res) => {
                    this.loading = false;
                    resolve(convertSettings(res.data));
                });
            });
        },

        isCustomerSupport() {
            return this.userRole === 'CustomerSup';
        },
    },
};
</script>

<style scoped>
.login__container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
}

.login {
    width: 450px;
}

.logo {
    width: 160px;
    height: auto;
}

.logo img {
    width: 100%;
    height: 100px;
}

.container {
    padding: 30px;
}

.el-menu__logout {
    align-items: flex-end;
    flex-grow: 1;
    display: flex;
    padding: 0 20px;
    margin-bottom: 30px;
}

.el-menu__logout-button {
    width: 100%;
}

.el-menu {
    background-color: #f5f6f7;
    position: relative;
}

.el-menu--vertical {
    display: flex;
    position: fixed;
    flex-direction: column;
    height: 100vh;
    width: 200px;
    overflow: hidden;
}

.el-menu--horizontal > .el-menu-item:hover {
    background-color: #ebecec;
}

.el-menu--horizontal > .el-menu-item.is-active {
    background-color: #f5f6f7;
}

.el-header {
    background-color: #b3c0d1;
    color: #333;
    text-align: center;
    line-height: 60px;
}

.el-aside {
    background-color: #545c64;
    color: #333;
    line-height: 200px;
}

.el-main {
    min-height: 100vh;
    background-color: #e9eef3;
    color: #333;
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// Admin.vue?29fb4632